import styles from '../../assets/css/redirection.module.css';
import StepHeader from '../StepHeader';
import { useTranslation } from 'react-i18next';
import { REDIRECTING_PREFIX } from '../../utils/translationPagePrefix';

interface RedirectingProps {
	bankName: string;
	bankLogo: string;
}

const Redirecting = ({ bankName, bankLogo }: RedirectingProps) => {
	const { t } = useTranslation();

	const title = t(`${REDIRECTING_PREFIX}.title`, { bankName });
	const subtitle = t(`${REDIRECTING_PREFIX}.subtitle`);

	return (
		<div className={styles['redirecting-container']}>
			<StepHeader title={title} subtitle={subtitle} bankName={bankName} withSpinner={true} bankLogo={bankLogo} />
		</div>
	);
};

export default Redirecting;
